import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-legal-documentation',
  templateUrl: './legal-documentation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./legal-documentation.component.css'],
})
export class LegalDocumentationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
